import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	devOps: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.dev-ops.dev-ops',
		defaultMessage: 'DevOps',
		description: 'DevOps links group title',
	},
	cycleTime: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.dev-ops.cycle-time',
		defaultMessage: 'Cycle time report',
		description: 'Cycle time link item',
	},
	deploymentFrequency: {
		id: 'spa-apps-sidebar-software-classic.menu.reports.dev-ops.deployment-frequency',
		defaultMessage: 'Deployment frequency report',
		description: 'Deployment frequency link item',
	},
});
